import { groupBy } from 'lodash';
import { getFramework } from '@/framework';
import { getCharTypedMarkerText, getSVGMarkerNumberText } from '@/utils/text-kit';
import { type ILayerBehavior, type ITextLayerProps } from '@/version-types';

type Behaviors = Pick<ILayerBehavior, 'getTextInfo'>;

export const createFontBehaviors = (identity: string) => {
    const behaviors: Behaviors = {
        /**
         * 获取文本信息
         *
         * @param layer - 图层属性
         */
        getTextInfo(layer) {
            const layerData = layer.data as ITextLayerProps;
            const { textContents = [], text, fontFamily, listStyle, listStyleMaterial } = layerData;

            let temp: { fontFamily: string; text: string }[] = [];

            if (textContents.length > 0) {
                temp = textContents.map((item) => ({
                    fontFamily: item.fontFamily || layerData.fontFamily,
                    text: item.text,
                }));
            } else {
                temp = [{ fontFamily, text }];
            }

            const paragraphCount = Math.max(text.split('\n').length, 1);

            if (listStyle === 'custom') {
                if (listStyleMaterial?.autoIncrement !== 'none' && listStyleMaterial?.fontId) {
                    const fontList = getFramework(identity).service.font.getFonts();
                    const font = fontList.find((item) => item.id === listStyleMaterial.fontId);

                    if (font) {
                        const markerText = Array.from({ length: paragraphCount }, (_, index) =>
                            getSVGMarkerNumberText(listStyleMaterial.autoIncrement, index + 1, {
                                padZero: listStyleMaterial.padZero,
                            }),
                        ).join('');
                        temp.push({ fontFamily: font.name, text: markerText });
                    }
                }
            } else if (listStyle) {
                const markerText = Array.from({ length: paragraphCount }, (_, index) =>
                    getCharTypedMarkerText(listStyle, index + 1),
                ).join('');
                temp.push({ fontFamily, text: markerText });
            }

            // 聚合相同字体
            const group = groupBy(temp, (item) => item.fontFamily);

            // HACK: https://jira.meitu.com/browse/MTXXPRO-63831
            // 在每种字体的文本后添加数字，以返回的子集不会应为集合内没有该字体导致 Safari 下子集异常
            const ret = Object.keys(group).map((fontFamily) => ({
                fontFamily,
                text: group[fontFamily].map((item) => item.text).join(''), // + '0123456789', // 使用新引擎测量文本尺寸时，不需要添加数字，待测试
            }));

            return ret;
        },
    };

    return behaviors;
};
